// Import axe-core accessibility testing engine
import axe from 'axe-core'

/**
 * run axe-core accessibility testing engine
 * https://github.com/dequelabs/axe-core
 */
export function runAxe() {
	axe
		.run()
		.then((results) => {
			const violations = results.violations
			if (violations.length) {
				violations.forEach((violation) => {
					const impact = violation.impact
					const axeMessage = `[AXE] ${impact} accessibility issue:`
					if (impact === 'critical' || impact === 'serious') {
						console.error(axeMessage, violation)
					} else {
						console.warn(axeMessage, violation)
					}
				})
			}
		})
		.catch((err) => {
			console.error('Something bad happened:', err.message)
		})
}
